module.exports = {"data":{"message":"Hey Ninja! Your journey is just starting."}}


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/dummy.json
// module id = 2521
// module chunks = 0